var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7803 9.53033C15.0732 9.23744 15.0732 8.76256 14.7803 8.46967C14.4874 8.17678 14.0126 8.17678 13.7197 8.46967L9.75 12.4393L9.75 3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75L8.25 12.4393L4.28033 8.46967C3.98744 8.17678 3.51256 8.17678 3.21967 8.46967C2.92678 8.76256 2.92678 9.23744 3.21967 9.53033L8.46967 14.7803C8.76256 15.0732 9.23744 15.0732 9.53033 14.7803L14.7803 9.53033Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownArrow);
export default __webpack_public_path__ + "static/media/ic_down_arrow.d81bd69489d4afa27bb760f7c448b2dd.svg";
export { ForwardRef as ReactComponent };